// src/Context/AuthContext.js
import { createContext } from "react";

// Definir o contexto
export const AuthContext = createContext({});
